// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__24B5J","col":"Table_col__5ROw1","fulfillmentStatus":"Table_fulfillmentStatus__2Ob5h","emailCol":"Table_emailCol__1ZPPc"};